import { Factory } from "@/data/dao/Factory";
import { BookingDao } from "@/data/dao/service/BookingDao";
import type { IEvent } from "@/data/model/Booking";
import { DateTime } from "@/data/util/DateTime";

import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";

export class EventTableController {
    private $element: JQuery;
    private dao: BookingDao;
    private dataTable: DataTable<IEvent>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<BookingDao>(BookingDao);

        const tableConfig: IDataTableConfig<IEvent> = {
            columnMapping: [
                {
                    name: "Name",
                    property: "nameDe",
                },
                {
                    name: "Datum",
                    property: "start",
                    styles: { width: "25%" },
                    formatter: (m) => {
                        return (
                            DateTime.toPreciseDateTimeString(m.start) +
                            " bis " +
                            DateTime.toPreciseDateTimeString(m.end)
                        );
                    },
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            defaultSortAsc: true,
            locationDependend: true,
            defaultSortProperty: "start",
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IEvent>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.eventDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/booking/event/" + m.id;
            },
            (m) => {
                window.open("/booking/event/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => {
            this.dataTable.loadData(true);
        }, this);
    }
}
